import { render } from "./MyDashboard.vue?vue&type=template&id=6ee81db0&scoped=true"
import script from "./MyDashboard.vue?vue&type=script&lang=js"
export * from "./MyDashboard.vue?vue&type=script&lang=js"

import "./MyDashboard.vue?vue&type=style&index=0&id=6ee81db0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ee81db0"]])

export default __exports__